<template>
  <ul class="mensagens-flutuantes">
    <li v-if="mensagemVisivel" :class="['mensagem', 'mensagem_flutuante', 'mensagem_ativa', `mensagem_cor-${estilo}`]"
      role="alert" tabindex="0">
      <div class="mensagem__container-icone">
        <i :class="['far', `${icone || this.definirIcone(estilo) || 'fa-times-circle'}`, 'mensagem__icone']"
          aria-hidden="true"></i>
      </div>
      <div class="mensagem__conteudo">
        <h2 class="mensagem__titulo">{{ titulo || this.definirTitulo(estilo) }}</h2>
        <p class="mensagem__texto" v-html="this.texto"></p>
      </div>
      <button class="mensagem__botao-fechar" @click="$emit('close')" type="button">
        <i class="far fa-times mensagem__icone-botao" aria-hidden="true"></i>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['titulo', 'texto', 'estilo', 'mensagemVisivel', 'icone'],
  methods: {
    definirIcone(estilo) {
      let icones = {
        "info": "fa-info-circle",
        "sucesso": "fa-check-circle",
        "erro": "fa-times-circle",
        "atencao": "fa-exclamation-circle"
      };
      return icones[estilo];
    },
    definirTitulo(estilo) {
      const titulosPorEstilo = {
        'sucesso': 'Tudo certo!',
        'erro': 'Identificamos um erro:',
        'atencao': 'Fique atento:',
        'info': 'Confira a informação:'
      };

      return titulosPorEstilo[estilo];
    }
  }
};
</script>


// WEBPACK FOOTER //
// MensagemFlutuante.vue?d9feda40